(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["niimbot-label-customizer"] && !Shopify.designMode) return;
  try {
    
  class NiimbotLabelCustomizer extends HTMLElement {
    connectedCallback() {
      this.scale = Number(this.dataset.scale) || 8;
      this.state = {
        widthMm: Number(this.dataset.defaultWidth) || 50,
        heightMm: Number(this.dataset.defaultHeight) || 30,
        labelStyle: this.dataset.defaultStyle || 'standard',
        labelColor: this.dataset.defaultColor || '#ffffff',
        text: this.dataset.defaultText || '',
        textColor: '#111111',
        textSize: 14,
        textX: 50,
        textY: 70,
        logoScale: 40,
        logoX: 10,
        logoY: 10,
        logoSrc: null,
        logoFile: null,
        logoFileName: null,
        logoNaturalWidth: 0,
        logoNaturalHeight: 0
      };

      this.label = this.querySelector('[data-label]');
      this.logo = this.querySelector('[data-logo]');
      this.text = this.querySelector('[data-text]');
      this.dimensions = this.querySelector('[data-dimensions]');
      this.exportCanvas = this.querySelector('[data-export-canvas]');
      this.customSizeRow = this.querySelector('[data-custom-size]');
      this.requestDialog = this.querySelector('[data-request-dialog]');
      this.contactForm = this.querySelector('[data-contact-form]');

      if (this.restoreFromShareLink()) {
        if (this.isRound()) {
          this.syncRoundPresetFromSize();
        } else {
          this.syncPresetFromSize();
        }
      }

      this.bindControls();
      this.bindDrag(this.logo, 'logo');
      this.bindDrag(this.text, 'text');
      if (this.isRound()) {
        this.enforceRoundDimensions();
      }
      this.updateSizeControls();
      if (this.isRound()) {
        this.syncRoundPresetFromSize();
      } else {
        this.syncPresetFromSize();
      }
      this.render();
    }

    bindControls() {
      const sizePreset = this.querySelector('[data-size-preset]');
      const roundSizePreset = this.querySelector('[data-round-size-preset]');
      const widthInput = this.querySelector('[data-width]');
      const heightInput = this.querySelector('[data-height]');
      const labelStyle = this.querySelector('[data-label-style]');
      const labelColor = this.querySelector('[data-label-color]');
      const colorField = this.querySelector('[data-color-field]');
      const logoInput = this.querySelector('[data-logo-input]');
      const logoScale = this.querySelector('[data-logo-scale]');
      const logoX = this.querySelector('[data-logo-x]');
      const logoY = this.querySelector('[data-logo-y]');
      const removeLogo = this.querySelector('[data-remove-logo]');
      const textInput = this.querySelector('[data-text-input]');
      const textColor = this.querySelector('[data-text-color]');
      const textSize = this.querySelector('[data-text-size]');
      const textX = this.querySelector('[data-text-x]');
      const textY = this.querySelector('[data-text-y]');
      const openRequest = this.querySelector('[data-open-request]');
      const closeRequestButtons = this.querySelectorAll('[data-close-request]');
      const reset = this.querySelector('[data-reset]');

      sizePreset.addEventListener('change', () => {
        if (sizePreset.value === 'custom') {
          this.customSizeRow.hidden = false;
        } else {
          this.customSizeRow.hidden = true;
          const [width, height] = sizePreset.value.split('x').map(Number);
          this.state.widthMm = width;
          this.state.heightMm = height;
          widthInput.value = width;
          heightInput.value = height;
          this.render();
        }
      });

      roundSizePreset.addEventListener('change', () => {
        if (roundSizePreset.value === 'custom') {
          this.customSizeRow.hidden = false;
        } else {
          this.customSizeRow.hidden = true;
          const size = Number(roundSizePreset.value);
          this.state.widthMm = size;
          this.state.heightMm = size;
          widthInput.value = size;
          heightInput.value = size;
          this.render();
        }
      });

      widthInput.addEventListener('input', () => {
        this.state.widthMm = Number(widthInput.value) || 10;
        if (this.isRound()) {
          this.enforceRoundDimensions();
          roundSizePreset.value = 'custom';
        } else {
          sizePreset.value = 'custom';
        }
        this.customSizeRow.hidden = false;
        this.render();
      });

      heightInput.addEventListener('input', () => {
        if (this.isRound()) return;
        this.state.heightMm = Number(heightInput.value) || 10;
        sizePreset.value = 'custom';
        this.customSizeRow.hidden = false;
        this.render();
      });

      labelStyle.addEventListener('change', () => {
        this.state.labelStyle = labelStyle.value;
        if (this.isRound()) {
          this.enforceRoundDimensions();
        }
        this.updateSizeControls();
        if (this.isRound()) {
          this.syncRoundPresetFromSize();
        } else {
          this.syncPresetFromSize();
        }
        this.render();
      });

      labelColor.addEventListener('input', () => {
        this.state.labelColor = labelColor.value;
        this.render();
      });

      logoInput.addEventListener('change', () => {
        const file = logoInput.files && logoInput.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
          const image = new Image();
          image.onload = () => {
            this.state.logoSrc = reader.result;
            this.state.logoFile = file;
            this.state.logoFileName = file.name;
            this.state.logoNaturalWidth = image.naturalWidth;
            this.state.logoNaturalHeight = image.naturalHeight;
            this.logo.hidden = false;
            this.logo.src = reader.result;
            removeLogo.hidden = false;
            this.render();
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      });

      logoScale.addEventListener('input', () => {
        this.state.logoScale = Number(logoScale.value);
        this.render();
      });

      logoX.addEventListener('input', () => {
        this.state.logoX = Number(logoX.value);
        this.render();
      });

      logoY.addEventListener('input', () => {
        this.state.logoY = Number(logoY.value);
        this.render();
      });

      removeLogo.addEventListener('click', () => {
        this.state.logoSrc = null;
        this.state.logoFile = null;
        this.state.logoFileName = null;
        this.logo.hidden = true;
        this.logo.removeAttribute('src');
        logoInput.value = '';
        removeLogo.hidden = true;
        this.render();
      });

      textInput.addEventListener('input', () => {
        this.state.text = textInput.value;
        this.render();
      });

      textColor.addEventListener('input', () => {
        this.state.textColor = textColor.value;
        this.render();
      });

      textSize.addEventListener('input', () => {
        this.state.textSize = Number(textSize.value);
        this.render();
      });

      textX.addEventListener('input', () => {
        this.state.textX = Number(textX.value);
        this.render();
      });

      textY.addEventListener('input', () => {
        this.state.textY = Number(textY.value);
        this.render();
      });

      openRequest.addEventListener('click', () => {
        if (this.requestDialog) {
          this.resetDialogState();
          this.updateAttachmentsPreview();
          this.requestDialog.showModal();
        }
      });

      closeRequestButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (this.requestDialog) {
            this.requestDialog.close();
          }
        });
      });

      if (this.contactForm) {
        this.contactForm.addEventListener('submit', (event) => {
          event.preventDefault();
          this.handleContactSubmit();
        });
      }

      reset.addEventListener('click', () => this.resetForm());
    }

    resetDialogState() {
      const successBanner = this.querySelector('[data-submit-success]');
      const dialogContent = this.querySelector('[data-dialog-content]');
      if (successBanner) successBanner.hidden = true;
      if (this.contactForm) this.contactForm.hidden = false;
      if (dialogContent) {
        const title = dialogContent.querySelector('.nlc__dialog-title');
        const text = dialogContent.querySelector('.nlc__dialog-text');
        const attachments = dialogContent.querySelector('[data-attachments-preview]');
        if (title) title.hidden = false;
        if (text) text.hidden = false;
        if (attachments) attachments.hidden = false;
      }
      this.clearSubmitError();
    }

    hasSubmissionEndpoint() {
      return Boolean(this.dataset.submissionEndpoint && this.dataset.submissionEndpoint.trim());
    }

    async fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result;
          if (typeof result !== 'string') {
            reject(new Error(this.dataset.errorUnableReadFile || 'Unable to read file'));
            return;
          }
          const commaIndex = result.indexOf(',');
          resolve(commaIndex >= 0 ? result.slice(commaIndex + 1) : result);
        };
        reader.onerror = () => reject(new Error(this.dataset.errorUnableReadFile || 'Unable to read file'));
        reader.readAsDataURL(file);
      });
    }

    async submitDesignRequest(contact) {
      const endpoint = this.dataset.submissionEndpoint.trim();
      const token = (this.dataset.submissionToken || '').trim();
      if (!token) {
        throw new Error(this.dataset.errorTokenMissing || 'Submission token is not configured.');
      }

      const config = this.buildConfiguration();
      const payload = {
        token,
        contact,
        summary: this.buildConfigurationSummary(),
        configJson: JSON.stringify(config),
        shareLink: this.buildShareableDesignLink(),
        logoUploaded: config.logoUploaded
      };

      const previewBlob = await this.renderDesignToCanvas(10);
      if (previewBlob) {
        const previewFile = new File([previewBlob], this.getPreviewFileName(), { type: 'image/png' });
        payload.preview = {
          name: previewFile.name,
          mimeType: previewFile.type,
          data: await this.fileToBase64(previewFile)
        };
      }

      const logoFile = await this.getLogoAttachmentFile();
      if (logoFile) {
        const compressedLogo = await this.compressToJpeg(logoFile, 700, 0.85);
        if (compressedLogo) {
          payload.logo = {
            name: this.getLogoFileName(),
            mimeType: compressedLogo.type,
            data: await this.fileToBase64(compressedLogo)
          };
        }
      }

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      });

      let result = null;
      try {
        result = await response.json();
      } catch (error) {
        throw new Error(this.dataset.errorInvalidResponse || 'Submission endpoint returned an invalid response.');
      }

      if (!response.ok || !result || !result.ok) {
        throw new Error(result?.error || this.dataset.errorSubmissionFailed || 'Unable to send your design request.');
      }

      return result;
    }

    showSubmissionSuccess() {
      const successBanner = this.querySelector('[data-submit-success]');
      const dialogContent = this.querySelector('[data-dialog-content]');
      if (successBanner) successBanner.hidden = false;
      if (this.contactForm) this.contactForm.hidden = true;
      if (dialogContent) {
        const title = dialogContent.querySelector('.nlc__dialog-title');
        const text = dialogContent.querySelector('.nlc__dialog-text');
        const attachments = dialogContent.querySelector('[data-attachments-preview]');
        if (title) title.hidden = true;
        if (text) text.hidden = true;
        if (attachments) attachments.hidden = true;
      }
    }

    async handleContactSubmit() {
      if (!this.hasSubmissionEndpoint()) {
        this.showSubmitError(this.dataset.errorSubmissionNotConfigured || this.dataset.submitErrorMessage || 'Submission is not configured.');
        return;
      }

      const nameField = this.querySelector('[data-contact-name]');
      const emailField = this.querySelector('[data-contact-email]');
      const phoneField = this.querySelector('[data-contact-phone]');
      const messageField = this.querySelector('[data-contact-message]');
      const submitButton = this.querySelector('[data-submit-request]');
      this.clearSubmitError();

      const contact = {
        name: nameField ? nameField.value.trim() : '',
        email: emailField ? emailField.value.trim() : '',
        phone: phoneField ? phoneField.value.trim() : '',
        message: messageField ? messageField.value.trim() : ''
      };

      if (!contact.name || !contact.email) {
        this.showSubmitError(this.dataset.validationNameEmail || 'Please enter your name and email.');
        return;
      }

      const preparingLabel = this.dataset.preparingLabel || 'Sending...';
      const sendLabel = this.dataset.sendLabel || 'Submit design';

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = preparingLabel;
      }

      try {
        await this.submitDesignRequest(contact);
        this.showSubmissionSuccess();
      } catch (error) {
        const fallback = this.dataset.submitErrorMessage || 'Unable to send your design request. Please try again.';
        this.showSubmitError(error?.message || fallback);
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = sendLabel;
        }
      }
    }

    syncPresetFromSize() {
      const preset = this.querySelector('[data-size-preset]');
      const key = `${this.state.widthMm}x${this.state.heightMm}`;
      const option = Array.from(preset.options).find((entry) => entry.value === key);
      if (option) {
        preset.value = key;
        this.customSizeRow.hidden = true;
      } else {
        preset.value = 'custom';
        this.customSizeRow.hidden = false;
      }
    }

    syncRoundPresetFromSize() {
      const preset = this.querySelector('[data-round-size-preset]');
      const size = String(this.state.widthMm);
      const option = Array.from(preset.options).find((entry) => entry.value === size);
      if (option && this.state.widthMm === this.state.heightMm) {
        preset.value = size;
        this.customSizeRow.hidden = true;
      } else {
        preset.value = 'custom';
        this.customSizeRow.hidden = false;
      }
    }

    enforceRoundDimensions() {
      this.state.heightMm = this.state.widthMm;
      const heightInput = this.querySelector('[data-height]');
      const widthInput = this.querySelector('[data-width]');
      if (heightInput) {
        heightInput.value = this.state.heightMm;
      }
      if (widthInput) {
        widthInput.value = this.state.widthMm;
      }
    }

    updateSizeControls() {
      const rectSizeField = this.querySelector('[data-rect-size-field]');
      const roundSizeField = this.querySelector('[data-round-size-field]');
      const heightField = this.querySelector('[data-height-field]');
      const widthLabel = this.querySelector('[data-width-label]');
      const customSizeRow = this.querySelector('[data-custom-size]');

      if (this.isRound()) {
        rectSizeField.hidden = true;
        roundSizeField.hidden = false;
        heightField.hidden = true;
        if (widthLabel) {
          widthLabel.textContent = this.dataset.roundWidthLabel || this.dataset.widthLabel || '';
        }
        if (customSizeRow && !customSizeRow.hidden) {
          customSizeRow.classList.add('nlc__field-row--single');
        }
      } else {
        rectSizeField.hidden = false;
        roundSizeField.hidden = true;
        heightField.hidden = false;
        if (widthLabel) {
          widthLabel.textContent = this.dataset.widthLabel || '';
        }
        if (customSizeRow) {
          customSizeRow.classList.remove('nlc__field-row--single');
        }
      }
    }

    mmToPx(mm) {
      return Math.round(mm * this.scale);
    }

    isTransparent() {
      return this.state.labelStyle === 'transparent' || this.state.labelStyle === 'round-transparent';
    }

    isRound() {
      return this.state.labelStyle === 'round' || this.state.labelStyle === 'round-transparent';
    }

    formatTemplate(template, values) {
      if (!template) return '';
      return Object.keys(values).reduce((result, key) => {
        return result.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), String(values[key]));
      }, template);
    }

    styleLabel() {
      const labels = {
        standard: this.dataset.styleStandard,
        transparent: this.dataset.styleTransparent,
        round: this.dataset.styleRound,
        'round-transparent': this.dataset.styleRoundTransparent
      };
      return labels[this.state.labelStyle] || this.state.labelStyle;
    }

    render() {
      const widthPx = this.mmToPx(this.state.widthMm);
      const heightPx = this.mmToPx(this.state.heightMm);
      const colorField = this.querySelector('[data-color-field]');
      const labelStyleInput = this.querySelector('[data-label-style]');

      this.label.style.width = `${widthPx}px`;
      this.label.style.height = `${heightPx}px`;
      this.label.classList.toggle('nlc__label--round', this.isRound());
      this.label.classList.toggle('nlc__label--transparent', this.isTransparent());

      if (this.isTransparent()) {
        this.label.style.backgroundColor = 'transparent';
        colorField.hidden = true;
      } else {
        this.label.style.backgroundColor = this.state.labelColor;
        colorField.hidden = false;
      }

      labelStyleInput.value = this.state.labelStyle;
      this.updateSizeControls();

      if (this.isRound()) {
        this.dimensions.textContent = `Ø ${this.state.widthMm} mm · ${this.styleLabel()}`;
      } else {
        this.dimensions.textContent = `${this.state.widthMm} × ${this.state.heightMm} mm · ${this.styleLabel()}`;
      }

      this.text.textContent = this.state.text;
      this.text.style.color = this.state.textColor;
      this.text.style.fontSize = `${this.state.textSize}px`;
      this.text.style.left = `${this.state.textX}%`;
      this.text.style.top = `${this.state.textY}%`;

      if (this.state.logoSrc) {
        const maxEdge = Math.min(widthPx, heightPx) * (this.state.logoScale / 100);
        const ratio = this.state.logoNaturalWidth / this.state.logoNaturalHeight || 1;
        let logoWidth = maxEdge;
        let logoHeight = maxEdge;

        if (ratio >= 1) {
          logoHeight = logoWidth / ratio;
        } else {
          logoWidth = logoHeight * ratio;
        }

        this.logo.style.width = `${logoWidth}px`;
        this.logo.style.height = `${logoHeight}px`;
        this.logo.style.left = `${(this.state.logoX / 100) * (widthPx - logoWidth)}px`;
        this.logo.style.top = `${(this.state.logoY / 100) * (heightPx - logoHeight)}px`;
      }

      this.querySelector('[data-logo-x]').value = this.state.logoX;
      this.querySelector('[data-logo-y]').value = this.state.logoY;
      this.querySelector('[data-text-x]').value = this.state.textX;
      this.querySelector('[data-text-y]').value = this.state.textY;
    }

    bindDrag(element, type) {
      let dragging = false;

      const updateFromPointer = (event) => {
        const rect = this.label.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        const clampedX = Math.max(0, Math.min(100, x));
        const clampedY = Math.max(0, Math.min(100, y));

        if (type === 'logo') {
          this.state.logoX = clampedX;
          this.state.logoY = clampedY;
        } else {
          this.state.textX = clampedX;
          this.state.textY = clampedY;
        }

        this.render();
      };

      element.addEventListener('pointerdown', (event) => {
        dragging = true;
        element.setPointerCapture(event.pointerId);
        updateFromPointer(event);
      });

      element.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        updateFromPointer(event);
      });

      element.addEventListener('pointerup', () => {
        dragging = false;
      });

      element.addEventListener('pointercancel', () => {
        dragging = false;
      });
    }

    buildConfiguration() {
      return {
        widthMm: this.state.widthMm,
        heightMm: this.state.heightMm,
        labelStyle: this.state.labelStyle,
        labelColor: this.isTransparent() ? null : this.state.labelColor,
        text: this.state.text,
        textColor: this.state.textColor,
        textSize: this.state.textSize,
        textX: this.state.textX,
        textY: this.state.textY,
        logoScale: this.state.logoScale,
        logoX: this.state.logoX,
        logoY: this.state.logoY,
        logoUploaded: Boolean(this.state.logoSrc),
        logoFileName: this.state.logoFileName || null
      };
    }

    buildConfigurationSummary() {
      const config = this.buildConfiguration();
      const yes = this.dataset.valueYes || 'Yes';
      const no = this.dataset.valueNo || 'No';
      const none = this.dataset.valueNone || '(none)';
      const transparent = this.dataset.valueTransparent || 'Transparent';
      const lines = [
        this.dataset.summaryTitle || '',
        '',
        this.isRound()
          ? this.formatTemplate(this.dataset.summarySizeRound, { size: config.widthMm })
          : this.formatTemplate(this.dataset.summarySizeRect, { width: config.widthMm, height: config.heightMm }),
        this.formatTemplate(this.dataset.summaryStyle, { style: this.styleLabel() }),
        this.formatTemplate(this.dataset.summaryBackground, { color: config.labelColor || transparent }),
        this.formatTemplate(this.dataset.summaryText, { text: config.text || none }),
        this.formatTemplate(this.dataset.summaryTextColor, { color: config.textColor }),
        this.formatTemplate(this.dataset.summaryTextSize, { size: config.textSize }),
        this.formatTemplate(this.dataset.summaryTextPosition, { x: config.textX, y: config.textY }),
        this.formatTemplate(this.dataset.summaryLogoUploaded, { value: config.logoUploaded ? yes : no })
      ];

      if (config.logoUploaded) {
        lines.push(this.formatTemplate(this.dataset.summaryLogoSize, { size: config.logoScale }));
        lines.push(this.formatTemplate(this.dataset.summaryLogoPosition, { x: config.logoX, y: config.logoY }));
        if (config.logoFileName) {
          lines.push(this.formatTemplate(this.dataset.summaryLogoFile, { filename: config.logoFileName }));
        }
      }

      return lines.join('\n');
    }

    renderDesignToCanvas(exportScale) {
      const widthPx = Math.round(this.state.widthMm * exportScale);
      const heightPx = Math.round(this.state.heightMm * exportScale);
      const canvas = this.exportCanvas;
      const context = canvas.getContext('2d');

      canvas.width = widthPx;
      canvas.height = heightPx;
      context.clearRect(0, 0, widthPx, heightPx);

      if (this.isRound()) {
        context.save();
        context.beginPath();
        context.ellipse(widthPx / 2, heightPx / 2, widthPx / 2, heightPx / 2, 0, 0, Math.PI * 2);
        if (!this.isTransparent()) {
          context.fillStyle = this.state.labelColor;
          context.fill();
        }
        context.clip();
      } else if (!this.isTransparent()) {
        context.fillStyle = this.state.labelColor;
        context.fillRect(0, 0, widthPx, heightPx);
      }

      const drawLogo = () => {
        if (!this.state.logoSrc) return Promise.resolve();

        return new Promise((resolve) => {
          const image = new Image();
          image.onload = () => {
            const maxEdge = Math.min(widthPx, heightPx) * (this.state.logoScale / 100);
            const ratio = image.naturalWidth / image.naturalHeight || 1;
            let logoWidth = maxEdge;
            let logoHeight = maxEdge;

            if (ratio >= 1) {
              logoHeight = logoWidth / ratio;
            } else {
              logoWidth = logoHeight * ratio;
            }

            const left = (this.state.logoX / 100) * (widthPx - logoWidth);
            const top = (this.state.logoY / 100) * (heightPx - logoHeight);
            context.drawImage(image, left, top, logoWidth, logoHeight);
            resolve();
          };
          image.onerror = () => resolve();
          image.src = this.state.logoSrc;
        });
      };

      const drawText = () => {
        if (!this.state.text) return;
        const fontSize = Math.round(this.state.textSize * (exportScale / this.scale));
        context.fillStyle = this.state.textColor;
        context.font = `600 ${fontSize}px system-ui, sans-serif`;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(
          this.state.text,
          (this.state.textX / 100) * widthPx,
          (this.state.textY / 100) * heightPx,
          widthPx * 0.9
        );
      };

      return drawLogo().then(() => {
        drawText();
        if (this.isRound()) {
          context.restore();
        }
        return new Promise((resolve) => {
          canvas.toBlob((blob) => resolve(blob), 'image/png');
        });
      });
    }

    getPreviewFileName() {
      const styleSuffix = this.state.labelStyle === 'standard' ? '' : `-${this.state.labelStyle}`;
      if (this.isRound()) {
        return `design-preview-${this.state.widthMm}mm-round${styleSuffix}.png`;
      }
      return `design-preview-${this.state.widthMm}x${this.state.heightMm}mm${styleSuffix}.png`;
    }

    getLogoFileName() {
      const baseName = (this.state.logoFileName || 'customer-logo').replace(/\.[^.]+$/, '');
      return `${baseName}.png`;
    }

    async getLogoAttachmentFile() {
      if (!this.state.logoSrc) return null;

      if (this.state.logoFile && this.state.logoFile.type === 'image/png') {
        return new File([this.state.logoFile], this.getLogoFileName(), { type: 'image/png' });
      }

      return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = image.naturalWidth || 1;
          canvas.height = image.naturalHeight || 1;
          const context = canvas.getContext('2d');
          context.drawImage(image, 0, 0);
          canvas.toBlob((blob) => {
            if (!blob) {
              resolve(null);
              return;
            }
            resolve(new File([blob], this.getLogoFileName(), { type: 'image/png' }));
          }, 'image/png');
        };
        image.onerror = () => resolve(null);
        image.src = this.state.logoSrc;
      });
    }

    updateAttachmentsPreview() {
      const wrapper = this.querySelector('[data-attachments-preview]');
      const list = this.querySelector('[data-attachments-list]');
      if (!wrapper || !list) return;

      const items = [this.getPreviewFileName()];
      if (this.state.logoSrc) {
        items.push(this.getLogoFileName());
      }
      items.push(this.hasSubmissionEndpoint()
        ? (this.dataset.attachmentDriveLinks || '')
        : (this.dataset.attachmentDesignFiles || ''));
      items.push(this.dataset.attachmentShareLink || '');

      list.innerHTML = items.map((name) => `<li>${name}</li>`).join('');
      wrapper.hidden = false;
    }

    async compressToJpeg(input, maxWidth, quality) {
      const blob = input instanceof Blob ? input : null;
      const file = input instanceof File ? input : null;
      const source = blob || file;
      if (!source) return null;

      return new Promise((resolve) => {
        const image = new Image();
        const objectUrl = URL.createObjectURL(source);
        image.onload = () => {
          const scale = Math.min(1, maxWidth / (image.naturalWidth || maxWidth));
          const width = Math.max(1, Math.round((image.naturalWidth || maxWidth) * scale));
          const height = Math.max(1, Math.round((image.naturalHeight || maxWidth) * scale));
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext('2d');
          context.drawImage(image, 0, 0, width, height);
          URL.revokeObjectURL(objectUrl);
          canvas.toBlob((jpegBlob) => {
            if (!jpegBlob) {
              resolve(source);
              return;
            }
            resolve(new File([jpegBlob], `${(file && file.name.replace(/\.[^.]+$/, '')) || 'image'}.jpg`, { type: 'image/jpeg' }));
          }, 'image/jpeg', quality);
        };
        image.onerror = () => {
          URL.revokeObjectURL(objectUrl);
          resolve(source);
        };
        image.src = objectUrl;
      });
    }

    buildShareableDesignLink() {
      const logoForShare = this.state.logoSrc && this.state.logoSrc.length <= 60000 ? this.state.logoSrc : null;
      const payload = {
        v: 1,
        widthMm: this.state.widthMm,
        heightMm: this.state.heightMm,
        labelStyle: this.state.labelStyle,
        labelColor: this.state.labelColor,
        text: this.state.text,
        textColor: this.state.textColor,
        textSize: this.state.textSize,
        textX: this.state.textX,
        textY: this.state.textY,
        logoScale: this.state.logoScale,
        logoX: this.state.logoX,
        logoY: this.state.logoY,
        logoFileName: this.state.logoFileName,
        logo: logoForShare
      };

      const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/g, '');
      const baseUrl = `${window.location.origin}${window.location.pathname}`;
      return `${baseUrl}?nlc=${encoded}`;
    }

    restoreFromShareLink() {
      const params = new URLSearchParams(window.location.search);
      const encoded = params.get('nlc');
      if (!encoded) return false;

      try {
        const padded = encoded.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(escape(atob(padded)));
        const payload = JSON.parse(json);
        if (!payload || payload.v !== 1) return false;

        this.state.widthMm = Number(payload.widthMm) || this.state.widthMm;
        this.state.heightMm = Number(payload.heightMm) || this.state.heightMm;
        this.state.labelStyle = payload.labelStyle || this.state.labelStyle;
        this.state.labelColor = payload.labelColor || this.state.labelColor;
        this.state.text = payload.text || '';
        this.state.textColor = payload.textColor || this.state.textColor;
        this.state.textSize = Number(payload.textSize) || this.state.textSize;
        this.state.textX = Number(payload.textX) || this.state.textX;
        this.state.textY = Number(payload.textY) || this.state.textY;
        this.state.logoScale = Number(payload.logoScale) || this.state.logoScale;
        this.state.logoX = Number(payload.logoX) || this.state.logoX;
        this.state.logoY = Number(payload.logoY) || this.state.logoY;
        this.state.logoFileName = payload.logoFileName || null;

        if (payload.logo) {
          this.state.logoSrc = payload.logo;
          this.logo.hidden = false;
          this.logo.src = payload.logo;
          this.querySelector('[data-remove-logo]').hidden = false;
        }

        this.querySelector('[data-width]').value = this.state.widthMm;
        this.querySelector('[data-height]').value = this.state.heightMm;
        this.querySelector('[data-label-style]').value = this.state.labelStyle;
        this.querySelector('[data-label-color]').value = this.state.labelColor;
        this.querySelector('[data-text-input]').value = this.state.text;
        this.querySelector('[data-text-color]').value = this.state.textColor;
        this.querySelector('[data-text-size]').value = this.state.textSize;
        this.querySelector('[data-logo-scale]').value = this.state.logoScale;
        return true;
      } catch (error) {
        return false;
      }
    }

    showSubmitError(message) {
      const errorBanner = this.querySelector('[data-submit-error]');
      if (errorBanner) {
        errorBanner.textContent = message;
        errorBanner.hidden = false;
      }
    }

    clearSubmitError() {
      const errorBanner = this.querySelector('[data-submit-error]');
      if (errorBanner) {
        errorBanner.textContent = '';
        errorBanner.hidden = true;
      }
    }

    resetForm() {
      this.state = {
        widthMm: Number(this.dataset.defaultWidth) || 50,
        heightMm: Number(this.dataset.defaultHeight) || 30,
        labelStyle: this.dataset.defaultStyle || 'standard',
        labelColor: this.dataset.defaultColor || '#ffffff',
        text: this.dataset.defaultText || '',
        textColor: '#111111',
        textSize: 14,
        textX: 50,
        textY: 70,
        logoScale: 40,
        logoX: 10,
        logoY: 10,
        logoSrc: null,
        logoFile: null,
        logoFileName: null,
        logoNaturalWidth: 0,
        logoNaturalHeight: 0
      };

      this.querySelector('[data-width]').value = this.state.widthMm;
      this.querySelector('[data-height]').value = this.state.heightMm;
      this.querySelector('[data-label-style]').value = this.state.labelStyle;
      this.querySelector('[data-label-color]').value = this.state.labelColor;
      this.querySelector('[data-text-input]').value = this.state.text;
      this.querySelector('[data-text-color]').value = this.state.textColor;
      this.querySelector('[data-text-size]').value = this.state.textSize;
      this.querySelector('[data-logo-scale]').value = this.state.logoScale;
      this.querySelector('[data-logo-input]').value = '';
      this.logo.hidden = true;
      this.logo.removeAttribute('src');
      this.querySelector('[data-remove-logo]').hidden = true;
      if (this.isRound()) {
        this.enforceRoundDimensions();
        this.syncRoundPresetFromSize();
      } else {
        this.syncPresetFromSize();
      }
      this.render();
    }
  }

  if (!customElements.get('niimbot-label-customizer')) {
    customElements.define('niimbot-label-customizer', NiimbotLabelCustomizer);
  }

  } catch(e) { console.error(e); }
})();
})();
